/**
 * Status vocabulary shared by every check and by the visual layer.
 *
 * The validator is explicitly allowed to say "I do not know" — an honest
 * `uncertain` / `not_checked` is always preferable to a fabricated pass.
 */
export const MEASUREMENT_STATUSES = ['pass', 'fail', 'warning', 'uncertain', 'not_checked'] as const;

export type MeasurementStatus = (typeof MEASUREMENT_STATUSES)[number];

/** How loudly a check result should be surfaced in the UI. */
export type Severity = 'info' | 'warning' | 'error';

/**
 * Whether a failed photo can be repaired by technical means (crop, resize,
 * re-encode) or whether the person has to be photographed again.
 */
export type Fixability = 'fixable' | 'retake' | 'none';

export type OverallVerdict = 'pass' | 'fail' | 'needs_review';

export const STATUS_ORDER: Record<MeasurementStatus, number> = {
  fail: 0,
  warning: 1,
  uncertain: 2,
  not_checked: 3,
  pass: 4,
};
